/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import {
    SET_INFOCARD_CALLER_SCREEN,
    SET_INFOCARD_GHOST_MODE,
    SET_INFOCARD_HIGHLIGHT,
    SET_INFOCARD_NAVIGATION_HIGHLIGHT,
    SET_INFOCARD_TIMER_ID,
} from './infocard.types';

export const setInfoCardCallerScreenAction = (
    callerScreenController: string,
    callerScreenTaskController: string,
): TivoPayloadAction<{ callerScreenController: string; callerScreenTaskController: string }> => ({
    type: SET_INFOCARD_CALLER_SCREEN,
    payload: { callerScreenController, callerScreenTaskController },
});

export const setInfoCardHighlightAction = (
    highlight: number,
): TivoPayloadAction<{ highlight: number }> => ({
    type: SET_INFOCARD_HIGHLIGHT,
    payload: { highlight },
});

export const setInfoCardGhostModeAction = (ghostMode: boolean) => ({
    type: SET_INFOCARD_GHOST_MODE,
    payload: { ghostMode },
});

export const setInfoCardTimerIdAction = (timerId: NodeJS.Timeout | null) => ({
    type: SET_INFOCARD_TIMER_ID,
    payload: {
        timerId,
    },
});

export const setLeftNavigationHighlightAction = (isCursorOverLeftArrow: boolean) => ({
    type: SET_INFOCARD_NAVIGATION_HIGHLIGHT,
    payload: {
        isCursorOverLeftArrow,
    },
});

export const setRightNavigationHighlightAction = (isCursorOverRightArrow: boolean) => ({
    type: SET_INFOCARD_NAVIGATION_HIGHLIGHT,
    payload: {
        isCursorOverRightArrow,
    },
});
